// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TableColumnSvg from '@rsuite/icon-font/lib/application/TableColumn';
var TableColumn = createSvgIcon({
  as: TableColumnSvg,
  ariaLabel: 'table column',
  category: 'application',
  displayName: 'TableColumn'
});
export default TableColumn;